import { EditorialTemplate} from "../domain/domain";

export type EditorialTemplatesState = {
    editorialTemplates : EditorialTemplate[] | undefined,
    selectedEditorialTemplate : EditorialTemplate | undefined,
}

const initialState: EditorialTemplatesState = {
    editorialTemplates : undefined,
    selectedEditorialTemplate : undefined,
}

export enum EditorialTemplatesActionType {
    EDITORIAL_TEMPLATES_LOADED = "EDITORIAL_TEMPLATES_LOADED",
    SELECTED_EDITORIAL_CHANGED = "SELECTED_EDITORIAL_CHANGED",
    EDITORIAL_TEMPLATE_ADDED = "EDITORIAL_TEMPLATE_ADDED",
    EDITORIAL_TEMPLATE_UPDATED = "EDITORIAL_TEMPLATE_UPDATED",
    EDITORIAL_TEMPLATE_DELETED = "EDITORIAL_TEMPLATE_DELETED"
}

export interface EditorialTemplatesLoaded {
    type: EditorialTemplatesActionType.EDITORIAL_TEMPLATES_LOADED,
    editorialTemplates: EditorialTemplate[],
}

export interface SelectedEditorialTemplateChanged {
    type: EditorialTemplatesActionType.SELECTED_EDITORIAL_CHANGED,
    newSelectedEditorialTemplate: EditorialTemplate,
}

export interface EditorialTemplateAdded {
    type: EditorialTemplatesActionType.EDITORIAL_TEMPLATE_ADDED,
    editorialTemplate: EditorialTemplate,
}

export interface EditorialTemplateUpdated {
    type: EditorialTemplatesActionType.EDITORIAL_TEMPLATE_UPDATED,
    editorialTemplate: EditorialTemplate,
}

export interface EditorialTemplateDeleted {
    type: EditorialTemplatesActionType.EDITORIAL_TEMPLATE_DELETED,
    editorialTemplate: EditorialTemplate
}

export type EditorialTemplatesActions = EditorialTemplateUpdated | EditorialTemplatesLoaded | SelectedEditorialTemplateChanged | EditorialTemplateAdded | EditorialTemplateDeleted

export function editorialTemplatesReducer(
    state = initialState,
    action: EditorialTemplatesActions
    ): EditorialTemplatesState {
        switch (action.type) {
            case EditorialTemplatesActionType.EDITORIAL_TEMPLATES_LOADED:
                return {
                    ...state,
                    editorialTemplates: action.editorialTemplates
                }
            case EditorialTemplatesActionType.SELECTED_EDITORIAL_CHANGED:
                return{
                    ...state,
                    selectedEditorialTemplate: action.newSelectedEditorialTemplate
                }
            case EditorialTemplatesActionType.EDITORIAL_TEMPLATE_ADDED:
                if (state.editorialTemplates === undefined) {
                    return state;
                }
                return {
                    ...state,
                    editorialTemplates: [...state.editorialTemplates, action.editorialTemplate]
                }
            case EditorialTemplatesActionType.EDITORIAL_TEMPLATE_UPDATED:
                if (state.editorialTemplates === undefined) {
                    return state;
                }
                let idx = state.editorialTemplates?.findIndex(edt => edt.id === action.editorialTemplate.id);
                if (idx < 0) {
                    return state;
                }
                let newEditorialTemplates = [...state.editorialTemplates];
                newEditorialTemplates[idx] = action.editorialTemplate;
                return {
                    ...state,
                    editorialTemplates: newEditorialTemplates
                }
            case EditorialTemplatesActionType.EDITORIAL_TEMPLATE_DELETED:
                if (state.editorialTemplates === undefined) {
                    return state;
                }
                let idx2 = state.editorialTemplates?.findIndex(edt => edt.id === action.editorialTemplate.id);
                if (idx2 < 0) {
                    return state;
                }
                let newEditorialTemplates2 = [...state.editorialTemplates];
                newEditorialTemplates2.splice(idx2, 1);
                let newSelectedEditorialTemplate = state.selectedEditorialTemplate;
                if (newSelectedEditorialTemplate !== undefined) {
                    if (newSelectedEditorialTemplate.id === action.editorialTemplate.id) {
                        newSelectedEditorialTemplate = newEditorialTemplates2.length > 0 ? newEditorialTemplates2[0] : undefined;
                    }
                }
                return {
                    ...state,
                    editorialTemplates: newEditorialTemplates2,
                    selectedEditorialTemplate: newSelectedEditorialTemplate
                }
            default:
                return state;
        }
    }